import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import React, { useEffect, useMemo, useState } from "react";
import { HeaderType, MainNavProps } from "../navigation/main/MainParamList";
import {
  Image,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { BottomButtonView } from "../../components/BottomButtonView";
import { showDialog } from "../../components/CommonDialog";
import { blackOperator, friendApplyDeal } from "../../net/service";
import { NewFriendStatus } from "../../realm/contactSchema";
import { useNavigationToChatView2 } from "../Chat/chat-helper";
import { User } from "../../../imsdk/db/t_user";
import { UserRef } from "../../../imsdk/db/t_user_ref";
import * as ImSdk from "../../../imsdk/api";
import { createChat, toSingleChat } from "./CreateChat";
import {
  color_333333,
  color_666666,
  color_E9E9E9,
  color_main,
  white,
} from "../../assets/style/colors";
import { CommonSetting } from "../../components/setting/CommonSetting";
import time from "../../../imsdk/time";
import {
  Str_Account,
  Str_AddFriends,
  Str_AddFriendBlackTip,
  Str_Cancel,
  Str_ContactDeleted,
  Str_Describe,
  Str_JoinBlacklist,
  Str_Label,
  Str_Nick,
  Str_Remarks,
  Str_SendMsg,
  Str_ThroughVerification,
} from "../../language/string_res";
import { isSystemAcc, LeftView } from "../Chat/CListItem";
import { useIsFocused } from "@react-navigation/native";
import { MQEventCallBack } from "../../../imsdk/api/mq";
import { useStore } from "../../store/UserStore";
import { buildSingleTopicId } from "../../utils/helper";
import { TopicWithSummary } from "../../../imsdk/api/topic";
import { useChatStore } from "../../store/ChatStore";
import globalEventBus from "../../utils/EventBus";
import { RemarkType } from "../Mine/MineRemark";
import { buildSignalTopicId, getAvatarByUser } from "../../utils/utils";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";
import { useAppNavigation } from "../navigation";
import MoreIcon from "../../assets/svg/icon_more.svg";
import { t } from "i18next";

interface ContactInfoProps {
  current: any;
  type?: HeaderType;
  isTab?: boolean;
  fromBlackList?: boolean;
  finishAll?: boolean;
}
const ContactInfoComponent = (prpos: ContactInfoProps) => {
  const { current, type, isTab, fromBlackList, finishAll } = prpos || {};
  const navigation = useAppNavigation();
  const uid = current.uid;
  const toChatView = useNavigationToChatView2();
  const { state, dispatch } = useStore();
  const { chatState, chatDispatch } = useChatStore();
  const [user, setUser] = useState<User>();
  const [userRef, setUserRef] = useState<UserRef>();
  const [isBlack, setIsBlack] = useState(false);
  const [label, setLabel] = useState("");
  const im = ImSdk.getInstance();
  const isSelf = uid === im.CurrentUid();
  const isFocused = useIsFocused();

  useEffect(() => {
    loadData();
    const syncCallback: MQEventCallBack = async (res) => {
      if (res.type === "contact_refresh") {
        loadData();
        return;
      }
    };

    // 监听黑名单状态变化事件
    const handleUserBlack = () => {
      loadData();
    };

    // 监听备注修改事件，确保第三栏也能同步更新
    const handleRemarkObj = (payload: any) => {
      if (payload && payload.user_remark && payload.user_remark.uid === uid) {
        setUser(prev => prev ? { ...prev, remark: payload.user_remark.remark } : prev);
      }
    };

    im.on("contact_refresh", syncCallback);
    im.on("user_black", handleUserBlack);
    globalEventBus.on("Set_Remark_USER", onOk);
    globalEventBus.on("Set_Remark_USER", handleRemarkObj);
    return () => {
      im.off("contact_refresh", syncCallback);
      im.off("user_black", handleUserBlack);
      globalEventBus.off("Set_Remark_USER", onOk);
      globalEventBus.off("Set_Remark_USER", handleRemarkObj);
    };
  }, [uid]);

  useEffect(() => {
    if (isFocused) {
      loadLabel();
    }
  }, [isFocused]);

  function loadLabel() {
    im.GetLabelsByUid(uid).then((r) => {
      if (r.labels) {
        if (r.labels.length > 0) {
          const lbs = r.labels.map((v) => v.label);
          const str = lbs.join(", ");
          setLabel(str);
        } else {
          setLabel("");
        }
      }
    });
  }

  const canSendMsg = useMemo<boolean>((): boolean => {
    if (!user) {
      return false;
    }
    // 用户已经被删除了
    if (user && user.status === "deleted") {
      return false;
    }
    // 是自己可以发送
    if (isSelf) {
      return true;
    }
    // 通讯录里有信息
    if (userRef) {
      return userRef?.isfriend === 1;
    }
    return false;
  }, [userRef, user, uid]);
  const canAddFriend = useMemo<boolean>((): boolean => {
    // 机器人不能加好友
    if (uid < 10000) {
      return false;
    }
    // 是自己不展示加好友
    if (uid === im.CurrentUid()) {
      return false;
    }

    // 用户信息都还没有 不能加
    if (!user) {
      return false;
    }
    // 用户已经删除了 不能加
    if (user.status === "deleted") {
      return false;
    }
    // 已经是好友了
    if (userRef && userRef.isfriend === 1) {
      return false;
    }

    // 对方是P端可以加
    if (user && user.appkey.startsWith("P")) {
      return true;
    }
    const myplat = im.CurrentAppkey().charAt(0);
    // 自己是P端可以加
    if (myplat === "P") {
      return true;
    }
    // 对方跟自己平台一样，可以加
    if (user && user.appkey.charAt(0) === myplat) {
      return true;
    }

    // 其它
    return false;
  }, [user, userRef, uid]);

  function loadData() {
    //先查询本地用户信息
    im.GetUser(uid, true).then((res) => {
      if (res.user) {
        setUser(res.user);
      }

      //再查询远端用户信息
      im.GetUserRemote(uid).then((res) => {
        if (res.users && res.users.length > 0) {
          setUser(res.users[0]);
        }
      });
    });

    im.GetContact({ uid: current.uid }).then((res) => {
      if (res.refs && res.refs.length > 0) {
        setUserRef(res.refs[0]);
      }
    });

    // 重新获取黑名单状态
    im.GetFriendBlack().then((res) => {
      if (res.blacks) {
        const isInBlackList = res.blacks.some((item) => item.uid === uid);
        setIsBlack(isInBlackList);
      } else {
        // 当 res.blacks 为 undefined 时，设置 isBlack 为 false
        setIsBlack(false);
      }
    }).catch((error) => {
      setIsBlack(false);
    });
  }

  // 点击发送消息 - 使用三栏布局，不跳转页面
  const handleSendClick = () => {
    // 如果是从黑名单进入|搜索好友进入，需要关闭两个页面
    if (fromBlackList || finishAll) {
      navigation.popToTop()
    }

    if (current && current.uid >= 0) {
      let topic: TopicWithSummary | undefined;
      const tid = buildSingleTopicId(im.CurrentUid(), current.uid);
      if (state && state.topicSummaryList.top) {
        const topics = state.topicSummaryList.top.filter(
          (v) => v.topic.tid === tid
        );
        if (topics.length > 0) {
          topic = topics[0];
        }
      }
      if (state && state.topicSummaryList.normal) {
        const topics = state.topicSummaryList.normal.filter(
          (v) => v.topic.tid === tid
        );
        if (topics.length > 0) {
          topic = topics[0];
        }
      }

      if (topic) {
        const users: User[] = [];
        if (user) {
          users.push(user);
        }
        if (state && state.user) {
          users.push(state.user as User);
        }
        topic.users = users;
        toChatView(topic);
      } else {
        createChat([current.uid], toChatView);
      }
    }
  };
  // 好友验证
  const handleVerifyClick = () => {
    friendApplyDeal({ applyUid: current.uid, op: "pass" }).then((resp) => {
      if (resp && resp.code === 0) {
        toSingleChat(current.uid, toChatView).then(() => { });
      }
    });
  };

  // 好友申请
  const handleApplyClick = () => {
    navigation.push("ContactApply", { uid: current.uid });
  };

  const handBlack = (newValue: boolean) => {
    ;
    // 注意：根据API文档，op=0是加入黑名单，op=1是拉出黑名单
    const op = newValue ? 0 : 1;
    blackOperator(uid, op).then((res) => {
      console.log("黑名单操作API返回:", res);
      if (res.code === 0) {
        setIsBlack(newValue);
        const im = ImSdk.getInstance();
        const black = newValue ? "1" : "";
        im.SetFriendBlack(uid, black).then((result) => {
          console.log("本地数据库黑名单状态更新结果:", result);
        });
        const eventData = {
          user_black: {
            uid: uid,
            black: black,
            time: time.toUnixMillSecond(time.now()),
          },
        };
        im.emit("user_black", eventData);
        // 触发黑名单页面更新，添加延迟以确保服务器状态已更新
        setTimeout(() => {
          globalEventBus.emit("BlackList_Update", {});
        }, 500);
      } else {
        setIsBlack(!newValue);
      }
    }).catch((error) => {
      setIsBlack(!newValue);
    });
  };

  const handBlackOperator = (newValue: boolean) => {
    if (newValue) {
      showDialog({
        message: Str_AddFriendBlackTip,
        outDismiss: false,
        cancelText: Str_Cancel,
        onCancel: () => {
          setIsBlack(false);
        },
        onConfirm: () => {
          handBlack(newValue);
        },
      });
    } else {
      handBlack(newValue);
    }
  };

  const onOk = (val: string) => {
    if (user) {
      setUser({ ...user, remark: val });
      im.UserModify({ uid: user.uid, remark: val });
      im.GroupUserRemarkModify(user.uid, val);
      im.emit("user_remark", { user_remark: { uid: user.uid, remark: val } });
      if (chatState.curTopicWithSummary.users) {
        const users = chatState.curTopicWithSummary.users;
        const index = users.findIndex((v) => v.uid === user.uid);
        if (index >= 0) {
          users[index].remark = val;
          chatDispatch({ type: "UPDATE_CHAT_USER", payload: [...users] });
        }
      }
    }
  };

  function isShowRight() {
    const b = !isSelf && userRef?.isfriend === 1 && !isSystemAcc(uid);
    return b;
  }
  function getNickName() {
    if (!user) {
      return "";
    }

    if (user.nick && user.nick.length) {
      return user.nick;
    }

    if (user.name && user.name.length) {
      return user.name;
    }
  }

  return (
    <View style={{ flex: 1 }}>
      {isTab && isShowRight() && (
        <NavBar
          title={""}
          showBack={false}
          rightClick={() => {
            navigation.navigate("ContactSetting", {
              current: current,
              isBlack: isBlack,
              key: `ContactSetting_${current.uid}_${Date.now()}`, // 添加唯一key，强制重新渲染组件
            });
          }}
          rightChildren={<MoreIcon width={24} height={24} />}
        />
      )}
      <ScrollView
        style={{ flex: 1 }}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          flexGrow: 1,
        }}
      >
        <View style={{ marginTop: 20, paddingHorizontal: 16 }}>
          <View
            style={{
              padding: 20,
              flexDirection: "row",
              backgroundColor: "white",
              alignItems: "center",
              borderRadius: 16,
              shadowColor: "#000",
              shadowOffset: {
                width: 0,
                height: 2,
              },
              shadowOpacity: 0.08,
              shadowRadius: 8,
              elevation: 3,
            }}
          >
            {LeftView(
              {
                left: {
                  avatar: user?.avatar || current.avatar,
                  uid: uid,
                  name: (user?.status === "deleted") ? Str_ContactDeleted : (user?.remark || user?.nick || user?.name || current.name || ""),
                },
                size: 60,
                isRounded: true,
                isGroup: false
              }
            )}
            <View
              style={{
                flex: 1,
              }}
            >
              {user ? (
                (user.status !== "deleted") && user?.remark && user?.remark.length > 0 ? (
                  <View style={styles.infoContainer}>
                    <Text
                      ellipsizeMode={"tail"}
                      numberOfLines={1}
                      style={styles.remarkText}
                    >
                      {user?.remark}
                    </Text>
                    <Text
                      ellipsizeMode={"tail"}
                      numberOfLines={1}
                      style={styles.nickText}
                    >
                      {/* 这里不能展示备注哦 */}
                      {Str_Nick}：{user?.nick || user?.name || user.employee || ""}
                    </Text>
                  </View>
                ) : (
                  <View style={styles.infoContainer}>
                    <Text
                      ellipsizeMode={"tail"}
                      numberOfLines={1}
                      style={styles.nameText}
                    >
                        {(user?.status === "deleted") ? Str_ContactDeleted : getNickName()}
                    </Text>
                  </View>
                )
              ) : null}

              {canSendMsg && user?.employee && user?.employee.length > 0 && (
                <Text style={styles.accountText}>
                  {Str_Account}：{user?.employee}
                </Text>
              )}
            </View>
          </View>

          {type === "NEW_FRIEND" && (
            <View style={styles.helloContainer}>
              <View style={styles.helloTextBox}>
                <Text style={styles.hello}>
                  {current.nick}：{current.hello}
                </Text>
              </View>
            </View>
          )}
        </View>
        {!isSelf && !isSystemAcc(uid) && (user?.status !== "deleted") && (
          <CommonSetting
            style={{
              marginHorizontal: 16,
              marginTop: 18,
              borderRadius: 16,
              shadowColor: "#000",
              shadowOffset: {
                width: 0,
                height: 2,
              },
              shadowOpacity: 0.08,
              shadowRadius: 8,
              elevation: 3,
            }}
            itemOption={[
              {
                onClick: () => {
                  navigation.navigate("MineRemark", {
                    type: RemarkType.USER,
                    id: uid,
                    currentValue: user?.remark,
                  });
                },
                rightText: user?.remark,
                text: Str_Remarks,
              },
              {
                onClick: () => {
                  if (user) {
                    navigation.navigate("ContactsLabel", { user: user });
                  }
                },
                rightText: label,
                text: Str_Label,
              },
              {
                text: Str_Describe,
                rightType: "Back",
                visible: false,
                onClick: () => { },
              },
              ...(fromBlackList
                ? [
                  {
                    text: Str_JoinBlacklist,
                    rightType: "Switch" as const,
                    switchIsEnabled: isBlack,
                    setIsEnabled: setIsBlack,
                    switchChange: (newValue: boolean) => handBlackOperator(newValue),
                  },
                ]
                : []),
            ]}
          />
        )}

        {/* 底部按钮区域 - 现在放在ScrollView内部，作为内容的一部分 */}
        <View style={styles.bottomButtonWrapper}>
          {type === "NEW_FRIEND" &&
            current.etime > time.toUnixMillSecond(time.now()) &&
            current.status !== NewFriendStatus.PASS &&
            current.status !== NewFriendStatus.REFUSE && (
              <BottomButtonView
                text={Str_ThroughVerification}
                onClick={handleVerifyClick}
                style={{
                  width: "100%",
                }}
              />
            )}

          {canSendMsg && (
            <BottomButtonView
              text={Str_SendMsg}
              onClick={handleSendClick}
              style={{
                width: "100%",
              }}
            />
          )}

          {type !== "NEW_FRIEND" && canAddFriend && (
            <BottomButtonView
              text={Str_AddFriends}
              onClick={handleApplyClick}
              style={{
                width: "100%",
              }}
            />
          )}
        </View>
      </ScrollView>
    </View>
  );
};
export const ContactInfo = ({
  navigation,
  route,
}: MainNavProps<"ContactInfo">) => {
  return (
    <View>
      <ContactInfoComponent
        current={route.params.current}
        type={route.params.type}
        isTab={route.params.isTab}
      />
    </View>
  );
};
export const ContactInfoModeal = ({
  route,
}: MainNavProps<"ContactInfoModeal">) => {
  return (
    <ScreenCloseModal>
      <ContactInfoComponent
        current={route.params.current}
        type={route.params.type}
        isTab={route.params.isTab}
        fromBlackList={route.params.fromBlackList}
        finishAll={route.params.finishAll}
      />
    </ScreenCloseModal>
  );
};
const styles = StyleSheet.create({
  nameWrap: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: color_main,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },

  helloContainer: {
    marginTop: 12,
    backgroundColor: "white",
    padding: 20,
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
  },

  helloTextBox: {
    backgroundColor: color_E9E9E9,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
  },

  hello: {
    fontSize: 14,
    color: color_666666,
    lineHeight: 20,
  },

  infoContainer: {
    marginLeft: 16,
    flex: 1,
  },

  remarkText: {
    fontSize: 20,
    color: color_333333,
    fontWeight: "600",
    marginBottom: 4,
  },

  nickText: {
    fontSize: 14,
    color: color_666666,
  },

  nameText: {
    fontSize: 20,
    color: color_333333,
    fontWeight: "600",
    marginLeft: 16,
  },

  accountText: {
    fontSize: 14,
    color: color_666666,
    marginTop: 8,
    marginLeft: 16,
  },

  bottomButtonWrapper: {
    marginTop: 20,
    marginBottom: 20,
  },
});
